// extracted by mini-css-extract-plugin
export default {"primeReplyWrapper":"PrimeCommunityReply_primeReplyWrapper__9YG3m"};